/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CredentialIssuanceConfigRequest,
  CredentialIssuanceExecutionRequest,
  CredentialIssuanceStartRequest,
  CredentialIssuanceStateResponse,
  IssuerNamesResponse,
  ResponseDto,
} from '../models/index';
import {
    CredentialIssuanceConfigRequestFromJSON,
    CredentialIssuanceConfigRequestToJSON,
    CredentialIssuanceExecutionRequestFromJSON,
    CredentialIssuanceExecutionRequestToJSON,
    CredentialIssuanceStartRequestFromJSON,
    CredentialIssuanceStartRequestToJSON,
    CredentialIssuanceStateResponseFromJSON,
    CredentialIssuanceStateResponseToJSON,
    IssuerNamesResponseFromJSON,
    IssuerNamesResponseToJSON,
    ResponseDtoFromJSON,
    ResponseDtoToJSON,
} from '../models/index';

export interface ConfigurationRequest {
    credentialIssuanceConfigRequest: CredentialIssuanceConfigRequest;
}

export interface ExecutionRequest {
    credentialIssuanceExecutionRequest: CredentialIssuanceExecutionRequest;
}

export interface StartOrFindRequest {
    credentialIssuanceStartRequest: CredentialIssuanceStartRequest;
}

export interface StatusRequest {
    workflow?: string;
}

/**
 * 
 */
export class CredentialIssuanceWorkflowControllerApi extends runtime.BaseAPI {

    /**
     * Async operation. Result can be found in the status endpoint
     * Configure existed Credential Issuance Workflow
     */
    async _configurationRaw(requestParameters: ConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['credentialIssuanceConfigRequest'] == null) {
            throw new runtime.RequiredError(
                'credentialIssuanceConfigRequest',
                'Required parameter "credentialIssuanceConfigRequest" was null or undefined when calling _configuration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/credential-issuance`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CredentialIssuanceConfigRequestToJSON(requestParameters['credentialIssuanceConfigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Async operation. Result can be found in the status endpoint
     * Configure existed Credential Issuance Workflow
     */
    async _configuration(requestParameters: ConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this._configurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel Credential Issuance workflow instance, called by user
     */
    async cancellationInstance2Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/credential-issuance`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Cancel Credential Issuance workflow instance, called by user
     */
    async cancellationInstance2(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.cancellationInstance2Raw(initOverrides);
        return await response.value();
    }

    /**
     * Async operation. Result can be found in the status endpoint
     * Starts the automatic issuance process with oobi resolving, issuing, admitting and the rest operations
     */
    async executionRaw(requestParameters: ExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['credentialIssuanceExecutionRequest'] == null) {
            throw new runtime.RequiredError(
                'credentialIssuanceExecutionRequest',
                'Required parameter "credentialIssuanceExecutionRequest" was null or undefined when calling execution().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/credential-issuance/execution`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CredentialIssuanceExecutionRequestToJSON(requestParameters['credentialIssuanceExecutionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Async operation. Result can be found in the status endpoint
     * Starts the automatic issuance process with oobi resolving, issuing, admitting and the rest operations
     */
    async execution(requestParameters: ExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.executionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of configured issuer names. Can be used to set IssueeAutomation and IssuerAutomation.
     * Get possible issuer names
     */
    async getIssuerNamesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IssuerNamesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/credential-issuance/issuer-names`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IssuerNamesResponseFromJSON(jsonValue));
    }

    /**
     * Get list of configured issuer names. Can be used to set IssueeAutomation and IssuerAutomation.
     * Get possible issuer names
     */
    async getIssuerNames(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IssuerNamesResponse> {
        const response = await this.getIssuerNamesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns all recipient workflow ids of Cred identity types.
     * Return recipient cred identity workflow ids
     */
    async recipientWorkflowsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CredentialIssuanceStateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/credential-issuance/recipient-identity-workflow`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CredentialIssuanceStateResponseFromJSON(jsonValue));
    }

    /**
     * Returns all recipient workflow ids of Cred identity types.
     * Return recipient cred identity workflow ids
     */
    async recipientWorkflows(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CredentialIssuanceStateResponse | null | undefined > {
        const response = await this.recipientWorkflowsRaw(initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * The only way to create the workflow
     * Start Credential Issuance Workflow or find if already exists for the current user
     */
    async startOrFindRaw(requestParameters: StartOrFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['credentialIssuanceStartRequest'] == null) {
            throw new runtime.RequiredError(
                'credentialIssuanceStartRequest',
                'Required parameter "credentialIssuanceStartRequest" was null or undefined when calling startOrFind().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/credential-issuance`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CredentialIssuanceStartRequestToJSON(requestParameters['credentialIssuanceStartRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * The only way to create the workflow
     * Start Credential Issuance Workflow or find if already exists for the current user
     */
    async startOrFind(requestParameters: StartOrFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.startOrFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Requests state machine and returns the status according to it. If workflow id is not set, finds one that was created by requester. If workflow is not found, returns 204
     * Return workflow status
     */
    async statusRaw(requestParameters: StatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CredentialIssuanceStateResponse>> {
        const queryParameters: any = {};

        if (requestParameters['workflow'] != null) {
            queryParameters['workflow'] = requestParameters['workflow'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/workflow/credential-issuance/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CredentialIssuanceStateResponseFromJSON(jsonValue));
    }

    /**
     * Requests state machine and returns the status according to it. If workflow id is not set, finds one that was created by requester. If workflow is not found, returns 204
     * Return workflow status
     */
    async status(requestParameters: StatusRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CredentialIssuanceStateResponse | null | undefined > {
        const response = await this.statusRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

}
